var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.501 10C19.501 15.2478 15.2479 19.5 10.001 19.5C4.75409 19.5 0.500977 15.2478 0.500977 10C0.500977 4.75411 4.75415 0.5 10.001 0.5C15.2478 0.5 19.501 4.75411 19.501 10Z",
    fill: "#84C70D",
    fillOpacity: 0.3,
    stroke: "#84C70D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99609 12.9287C10.4891 12.9287 10.8811 13.3217 10.8811 13.8037C10.8811 14.2857 10.4891 14.6787 10.0061 14.6787C9.52109 14.6787 9.12609 14.2857 9.12609 13.8037C9.12609 13.3217 9.51709 12.9287 9.99609 12.9287ZM9.99609 5.33594C10.4781 5.33594 10.8711 5.72894 10.8711 6.21094V10.6309C10.8711 11.1129 10.4781 11.5059 9.99609 11.5059C9.51409 11.5059 9.12109 11.1129 9.12109 10.6309V6.21094C9.12109 5.72894 9.51409 5.33594 9.99609 5.33594Z",
    fill: "#84C70D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/Info-Circle.3629d77108c893c36882ae3b976d9c69.svg";
export { ForwardRef as ReactComponent };